import { render } from "./RelatedNews.vue?vue&type=template&id=22709f4a"
import script from "./RelatedNews.vue?vue&type=script&lang=js"
export * from "./RelatedNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__